import { WeekTimeRecord } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function deleteTimeRecord(httpClient: HttpClient) {
  return (timeRecord: WeekTimeRecord) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/timesheet/timeRecord/${timeRecord.uuid}`,
        method: HttpMethods.DELETE,
      })
      .then(() => undefined)
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            timesheetDeadlineExceeded: "timesheetDeadlineExceeded",
          }),
        ),
      );
}

export { deleteTimeRecord };
